import { Grid } from '@mui/material';
import React from 'react';

import logoMeiji from '@common/assets/images/logo_meiji.svg';
import { useIsMobile } from '@common/utils/hooks';

/**
 * Site header bar with the Meiji logo.
 *
 * @param props - The component props.
 * @returns The rendered header bar.
 */
export function Header({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  return (
    <Grid
      data-test-id="header-selector"
      container
      justifyContent="space-between"
      alignItems="center"
      gap="16px"
      wrap="nowrap"
      sx={(theme) => ({
        backgroundColor: '#fff',
        px: '20px',
        py: '16px',
        [theme.breakpoints.down('md')]: {
          borderBottom: `1px solid ${theme.colors.secondary}`,
          px: '10px',
          py: '8px',
        },
      })}
    >
      <Grid item>
        <img
          src={logoMeiji}
          alt="Meiji Logo"
          style={{ maxWidth: isMobile ? '130px' : '248px' }}
        />
      </Grid>
      <Grid item>
        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          gap={isMobile ? '8px' : '16px'}
        >
          {React.Children.toArray(children).map((child, index) => (
            <Grid item key={index}>
              {child}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
